module.exports = __webpack_public_path__ + "img/3_117.94803243.png";